module.exports = __webpack_public_path__ + "img/logo_navbar.e94c83e9.png";